import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import localization from './javascript/localization'
import vuetify from './plugins/vuetify'
import moment from 'moment'
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons'
import './javascript/vee-validate'
import './plugins'
import linkify from 'vue-linkify'
 
Vue.directive('linkified', linkify)

import infiniteScroll from 'vue-infinite-scroll'


Vue.use(infiniteScroll)

Icon.register({
  'm-like': {
    width: 25.979,
    height: 24,
    viewBox : '0 0 25.979 24',
    paths: [
      {
        d:"M153.493,306.612a7.473,7.473,0,0,0-5.255-2.144h-.086a8.206,8.206,0,0,0-5.381,2.073,8.2,8.2,0,0,0-5.379-2.073h-.175a7.529,7.529,0,0,0-7.441,7.594c0,4.971,4.209,8.788,10.578,14.562l1.739,1.583a1,1,0,0,0,1.345,0l1.738-1.581c6.37-5.776,10.579-9.593,10.579-14.564v-.154A7.474,7.474,0,0,0,153.493,306.612Z", 
        transform:"translate(-129.776 -304.468)",
        class:"likeIcon",
        fill:"#F1797F",
      }
    ]
  },
  'm-like-outline': {
    width:"17.698", 
    height:"16.361", 
    viewBox:"0 0 17.698 16.361",
    paths: [
      {
        d:"M10.1,17.861,8.924,16.792C4.754,13.01,2,10.508,2,7.454A4.406,4.406,0,0,1,6.454,3,4.87,4.87,0,0,1,10.1,4.685,4.87,4.87,0,0,1,13.743,3,4.406,4.406,0,0,1,18.2,7.454c0,3.053-2.754,5.556-6.924,9.338Z", 
        transform:"translate(-1.25 -2.25)",
        //stroke:"#F1797F",
        fill:"none",
        class:"likeIconOutline"
      }
    ]
  },
  'm-share-outline': {
    width: 36.222,
    height: 23.999,
    viewBox : '0 0 36.222 23.999',
    paths: [
      {
        d:"M172.911,259.983a1,1,0,0,1-.951-1.308c3.506-10.8,14.427-15.35,21.136-17.164v-4.528a1,1,0,0,1,1.615-.788l13.037,10.185a1,1,0,0,1,0,1.576l-13.037,10.186a1,1,0,0,1-1.615-.788v-4.309c-3.058.043-12.653.679-19.527,6.691A1,1,0,0,1,172.911,259.983Zm22.185-20.95v3.25a1,1,0,0,1-.755.97c-5.492,1.388-14.662,4.807-19.027,12.694,8.1-5.141,17.644-4.939,18.821-4.893a1,1,0,0,1,.961,1V255.3l10.413-8.136Z", 
        transform:"translate(-171.911 -235.984)",
        class:"purpleIconOutline"
      }
    ]
  },
  'm-share': {
    width: 36.221,
    height: 24,
    viewBox : '0 0 36.221 24',
    paths: [
      {
        d:"M232.727,314.864,219.69,304.68a1,1,0,0,0-1.615.788v4.527c-6.71,1.815-17.631,6.366-21.137,17.164a1,1,0,0,0,1.61,1.062c6.873-6.013,16.469-6.649,19.527-6.692v4.309a1,1,0,0,0,1.615.788l13.037-10.186a1,1,0,0,0,0-1.576Z", 
        transform:"translate(-196.89 -304.468)" ,
        class:"purpleIcon"
      }
    ]
  },
  'm-bookmark': {
    width: 19.112,
    height: 24.001,
    viewBox : '0 0 19.112 24.001',
    paths: [
      {
        d:"M295.443,304.468H283.221a3.448,3.448,0,0,0-3.445,3.443v19.557a1,1,0,0,0,1.394.919l8.163-3.5,8.161,3.5a1,1,0,0,0,1.394-.919V307.911A3.448,3.448,0,0,0,295.443,304.468Z", 
        transform:"translate(-279.776 -304.468)",
        class:"bookmarkIcon"
      }
    ]
  },
  'm-bookmark-outline': {
    width: 19.111,
    height: 24.001,
    viewBox : '0 0 19.111 24.001',
    paths: [
      {
        d:"M272.909,259.983a.978.978,0,0,1-.393-.081l-8.162-3.5-8.163,3.5a.99.99,0,0,1-.944-.084,1,1,0,0,1-.449-.835V239.427a3.448,3.448,0,0,1,3.444-3.444h12.223a3.448,3.448,0,0,1,3.444,3.444v19.556a1,1,0,0,1-1,1Zm-14.667-22a1.445,1.445,0,0,0-1.444,1.444v18.04l7.163-3.07a1,1,0,0,1,.787,0l7.161,3.07v-18.04a1.445,1.445,0,0,0-1.444-1.444Z", 
        transform:"translate(-254.798 -235.983)",
        class:"purpleIconOutline"
      }
    ]
  },
  'm-comment': {
    width: 17.962,
    height: 18,
    viewBox : '0 0 17.962 18',
    paths: [
      {
        d:"M-258.738,653.321A9.432,9.432,0,0,0-265.01,651h-.012a9.429,9.429,0,0,0-6.283,2.321,7.718,7.718,0,0,0-2.7,5.814,7.45,7.45,0,0,0,.769,3.3,8.1,8.1,0,0,0,1.776,2.378,3.949,3.949,0,0,1-1.371,1.488,1.5,1.5,0,0,0-.477,1.79,1.5,1.5,0,0,0,1.378.909,1.5,1.5,0,0,0,.248-.021,11.348,11.348,0,0,0,4.744-1.849l.054-.035a9.925,9.925,0,0,0,1.857.174,9.431,9.431,0,0,0,6.284-2.321,7.718,7.718,0,0,0,2.7-5.813A7.718,7.718,0,0,0-258.738,653.321Zm-6.283,12.449a8.252,8.252,0,0,1-1.007-.061c-.249-.029-.489-.08-.729-.131-.081-.017-.163-.025-.243-.044a.234.234,0,0,0-.075,0,.513.513,0,0,0-.19.053l-.049.022c-.068.035-.144.079-.228.133-.223.141-.51.339-.889.559l-.027.015c-.176.1-.37.205-.588.309l-.048.022c-.219.1-.46.207-.728.307l-.048.017c-.276.1-.576.2-.909.286h-.017c-.344.09-.718.173-1.129.242h0a6.156,6.156,0,0,0,1.692-1.777c.5-.875.35-1.53.023-1.809a6.278,6.278,0,0,1-1.68-2.153,5.989,5.989,0,0,1-.61-2.623h0a6.341,6.341,0,0,1,2.618-5.037c.1-.073.2-.143.3-.212q.288-.2.6-.369a8.132,8.132,0,0,1,3.965-1.017h0a8.346,8.346,0,0,1,2.224.3,6.783,6.783,0,0,1,5.255,6.337c0,3.661-3.352,6.631-7.483,6.631Z", 
        transform:"translate(274.005 -651)",
        class:"purpleIconOutline"
      }
    ]
  }
})

Vue.component('m-icon', Icon)

Vue.config.productionTip = false

Vue.prototype.moment = moment

const i18n = localization.setLanguageSettings(Vue)
store.state.router = router
store.state.i18n = i18n


new Vue({
  vuetify,
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
